
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { AdminFooter } from '../../components/adminFooter/adminFooter.component'
import { JuryMemberCardAdmin } from '../../components/juryMemberCard/juryMemberCardAdmin.component'
import { Pagination } from '../../components/pagination/pagination.component'
import { getJuryDetailsAdmin } from '../../services/admin.service'
export const JuryMemberListAdminView = () => {

    const [juryList, setJuryList] = useState([])

    const [currentPage, setCurrentPage] = useState(1)

    const [juryListPerPage, setJuryListPerPage] = useState(10)

    const changePage = pageNumber => setCurrentPage(pageNumber)

    const setJuryListData = async () => {
        const { status, data } = await getJuryDetailsAdmin()
        if (status == 200) {
            setJuryList(data.juryData)
        }
    }

    useEffect(() => {
        setJuryListData()
    }, [])

    const indexOfLastJury = currentPage * juryListPerPage
    const indexOfFirstJury = indexOfLastJury - juryListPerPage
    const currenJuryList = juryList.slice(indexOfFirstJury, indexOfLastJury)

    return (
        <div className="app-content content">
            <div className="content-overlay" />
            <div className="header-navbar-shadow" />
            <div className="content-wrapper">
                <div className="content-body">
                    <div className="row">
                        <div className="col-lg-6 col-12">
                            <h2 className="mb-0">JURY MANAGMENT</h2>
                            <p className="font-lato font-12">{juryList.length} records</p>
                        </div>
                        {/* <div className="col-lg-6 col-12 text-right">
                            <Link
                                to="/jury-list/add-jury"
                                className="btn btn-primary font-lato text-white rounded-10 font-11 waves-effect waves-float waves-light"
                            >
                                <i className="fas fa-plus mr-1" />
                                Add new
                            </Link>
                        </div> */}
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="table-responsive">
                                <table className="table idea-table font-lato font-12">
                                    <tbody>
                                        {
                                            currenJuryList.map((data, index) => {
                                                return <JuryMemberCardAdmin key={index} juryId={data.ID} name={data.NAME} isActive={data.is_active} createdDate={data.createdAt} />
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <Pagination itemsPerPage={juryListPerPage} totalItems={juryList.length} changePage={changePage} currentPage={currentPage} />
                        </div>
                    </div>
                    <AdminFooter />
                </div>
            </div>
        </div>

    )
}